import * as Yup from "yup";

import {
  CreateReBrokerListForTreaty,
  CreateReBrokerListForTreatyVariables,
} from "_graphql/mutation/__generated__/CreateReBrokerListForTreaty";

import {
  AddBrokersTreatyForm,
} from "components/forms";
import { LocationGenerics } from "router/location";
import { Modal } from "components";
import _ from "lodash";
import toast from "react-hot-toast";
import {
  updateTreatyBrokers,
} from "_graphql/visal/mutations/treaty";
import { useFormik } from "formik";
import { useMatch } from "react-location";
import { useMutation } from "@apollo/client";
import { useTreaty } from "hooks/data/use-treaties";
import { wrapClick } from "utils";

export const validationSchema = Yup.object().shape({
  requests: Yup.array()
    .of(
      Yup.object().shape({
        participant_id: Yup.object().required("Participant is required"),
      })
    )
    .min(1)
    .required("At least one participant is required"),
});

export default function AddIntermediariesContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const { params } = useMatch<LocationGenerics>();
  const { loading: fetching, treaty } = useTreaty({
    treatyId: params.treaty || "",
  });
  const [create, { loading }] = useMutation<
    CreateReBrokerListForTreaty,
    CreateReBrokerListForTreatyVariables
  >(updateTreatyBrokers, {
    refetchQueries: ["Treaty", "GetTreatyBrokersParticipants"],
  });

  const form = useFormik<any>({
    initialValues: {
      requests: [],
      layer: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (variables) => {
      const items = _.groupBy(
        form.values.requests,
        "participant_id.re_broker.re_broker_id"
      );
      await create({
        variables: {
          brokersList: {
            treaty_id: params.treaty || "",
            broke_distribution: Object.keys(items)?.map((item: any) => ({
              re_broker_id: item,
              re_associate_ids: Object.values(items[item])?.map(
                (rep: any) => rep?.participant_id?.re_broker_associate_id
              ),
            })),
          },
        },
      }).then(({ data }) => {
        if (data?.createReBrokerListForTreaty) {
          toast.success("Intermediary list Updated Successfully");

          refetch?.();
          form.resetForm();
        } else {
          toast.error("Failed to update intermediary list");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={fetching}
      title="Add Intermediaries"
      description="Add intermediaries to this treaty"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Saving changes..." : "Save changes"}
          </button>
        </>
      )}
    >
      <AddBrokersTreatyForm form={form} treaty={treaty} />
    </Modal>
  );
}
